import { createUseStyles } from 'react-jss';

import { FontWeight, ITheme, mediaQuery } from '../../../styles';

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    item: {
      width: '50%',

      '&:nth-child(2n + 1) $itemContainer': {
        paddingRight: '24px',
      },
    },
    itemContainer: {
      paddingBottom: '24px',
    },
    itemTitle: {
      color: '#5A00EE',
      fontSize: '20px',
      lineHeight: '28px',
      fontWeight: FontWeight.Medium,
      marginBottom: '8px',
    },
    itemDescription: {
      color: '#5F5F5F',
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: FontWeight.Medium,
    },
    mobile: {
      [mediaQuery(breakpoints.laptop)]: {
        display: 'block !important',

        '& $item': {
          width: '100%',

          '&:nth-child(2n + 1) $itemContainer': {
            paddingRight: '0',
          },
        },
      },
    },
  }),
  { name: 'image-section-columns-info' },
);
